import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:    <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:   <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    Search:       <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    MapPin:       <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Star:         <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    Shield:       <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>,
    ShieldCheck:  <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    Award:        <><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></>,
    Search2:      <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    Calendar:     <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    Lock:         <><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    MessageCircle:<><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></>,
    Baby:         <><path d="M9 12h.01M15 12h.01"/><path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"/><path d="M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 3.5"/></>,
    Heart:        <><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></>,
    Sun:          <><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></>,
    Moon:         <><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></>,
    Backpack:     <><path d="M4 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/><path d="M8 21V8a4 4 0 0 1 8 0v13"/><path d="M8 3h8"/><path d="M10.5 3v3M13.5 3v3"/></>,
    Stethoscope:  <><path d="M11 2v2"/><path d="M5 2v2"/><path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 6 6 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2h-1"/><path d="M8 15a6 6 0 0 0 12 0v-3"/><circle cx="20" cy="10" r="2"/></>,
    PartyPopper:  <><path d="M5.8 11.3 2 22l10.7-3.79"/><path d="M4 3h.01M22 8h.01M15 2h.01M22 20h.01"/><path d="m22 2-1.5 1.5"/><path d="M14.5 5.5a3.5 3.5 0 0 1 0 5"/><path d="M9.5 11.5a3.5 3.5 0 0 0 5 0"/><path d="M19.5 10.5a3.5 3.5 0 0 1-5 0"/></>,
    FileCheck:    <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="m9 15 2 2 4-4"/></>,
    Users:        <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    ChevronDown:  <><path d="m6 9 6 6 6-6"/></>,
    ChevronUp:    <><path d="m18 15-6-6-6 6"/></>,
    Briefcase:    <><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ── Avatar ── */
function Avatar({ name, size = 42 }) {
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("");
  const colors = [
    { bg: T.g50, text: T.g700, border: T.g100 },
    { bg: "#fff7ed", text: "#c2410c", border: "#fed7aa" },
    { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
  ];
  const color = colors[name.charCodeAt(0) % colors.length];
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", flexShrink: 0, background: color.bg, border: `1.5px solid ${color.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.35, fontWeight: 600, color: color.text, fontFamily: T.sans }}>
      {initials}
    </div>
  );
}

function Stars({ rating, size = 13 }) {
  return (
    <div style={{ display: "inline-flex", gap: 2 }}>
      {[1, 2, 3, 4, 5].map(i => (
        <svg key={i} width={size} height={size} viewBox="0 0 24 24" fill={i <= rating ? T.amber : T.n150} stroke="none">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
  );
}

/* ── Location search bar ── */
function LocationSearchBar() {
  const navigate = useNavigate();
  const [location, setLocation] = useState("");

  const handleSearch = () => {
    const params = new URLSearchParams({ category: "childcare" });
    if (location.trim()) params.set("location", location.trim());
    navigate(`/search?${params.toString()}`);
  };

  return (
    <div style={{ display: "flex", gap: 10, maxWidth: 520, flexWrap: "wrap" }}>
      <div style={{ position: "relative", flex: "1 1 260px" }}>
        <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
          <Icon name="MapPin" size={16} color={T.n400} strokeWidth={2} />
        </span>
        <input
          type="text"
          value={location}
          onChange={e => setLocation(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleSearch()}
          placeholder="Enter your area or estate"
          style={{
            width: "100%", padding: "14px 14px 14px 42px",
            border: `1.5px solid ${T.n150}`, borderRadius: 12,
            fontSize: 14, fontFamily: T.sans, color: T.n900,
            background: T.white, outline: "none", boxSizing: "border-box",
          }}
          onFocus={e => (e.target.style.borderColor = T.g500)}
          onBlur={e => (e.target.style.borderColor = T.n150)}
        />
      </div>
      <button onClick={handleSearch} style={{
        display: "inline-flex", alignItems: "center", gap: 8,
        padding: "14px 24px", background: T.g500, color: T.white,
        border: "none", borderRadius: 12, fontSize: 14, fontWeight: 600,
        fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
      }}
      onMouseEnter={e => (e.currentTarget.style.background = T.g600)}
      onMouseLeave={e => (e.currentTarget.style.background = T.g500)}>
        <Icon name="Search" size={16} color={T.white} strokeWidth={2} />
        Find a caregiver
      </button>
    </div>
  );
}

/* ── Sub-service card ── */
const SUB_SERVICES = [
  { icon: "Baby",         name: "Occasional babysitting",   price: "KES 300 – 600",     unit: "per hour",  desc: "Short-notice or one-off babysitting for evenings out, errands, or appointments." },
  { icon: "Heart",        name: "Full-time nanny",          price: "KES 15,000 – 35,000", unit: "per month", desc: "Dedicated, ongoing childcare for your household, typically on a daily or live-in basis." },
  { icon: "Backpack",     name: "After-school care",        price: "KES 8,000 – 18,000", unit: "per month", desc: "Pickup, supervision, and care for school-age children in the afternoons and evenings." },
  { icon: "Moon",         name: "Newborn & infant care",     price: "KES 18,000 – 40,000", unit: "per month", desc: "Specialised care for infants, including feeding, sleep routines, and newborn support." },
  { icon: "Stethoscope",  name: "Special needs care",        price: "KES 500 – 1,200",   unit: "per hour",  desc: "Caregivers experienced in supporting children with additional or specialised care needs." },
  { icon: "PartyPopper",  name: "Holiday & event childcare", price: "KES 1,000 – 3,000", unit: "per event", desc: "Childcare coverage for parties, weddings, or holiday periods when regular care is unavailable." },
];

function SubServiceCard({ s }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "22px", borderRadius: 16,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .15s",
      }}>
      <div style={{ width: 42, height: 42, borderRadius: 12, background: T.g50, border: `1.5px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 14 }}>
        <Icon name={s.icon} size={19} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 6 }}>{s.name}</div>
      <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.65, margin: "0 0 14px" }}>{s.desc}</p>
      <div style={{ display: "flex", alignItems: "baseline", gap: 6, paddingTop: 12, borderTop: `1px solid ${T.n100}` }}>
        <span style={{ fontFamily: T.serif, fontSize: 17, fontWeight: 400, color: T.g700, letterSpacing: "-0.01em" }}>{s.price}</span>
        <span style={{ fontSize: 12, color: T.n400 }}>{s.unit}</span>
      </div>
    </div>
  );
}

/* ── How it works step ── */
function HowStep({ num, icon, title, desc }) {
  return (
    <div style={{ display: "flex", gap: 18, padding: "22px 0", borderBottom: `1px solid ${T.n100}` }}>
      <div style={{ width: 42, height: 42, borderRadius: 12, background: T.g50, border: `1.5px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Icon name={icon} size={18} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ flex: 1, paddingTop: 2 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 5 }}>Step {num}</div>
        <div style={{ fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 5 }}>{title}</div>
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: 0 }}>{desc}</p>
      </div>
    </div>
  );
}

/* ── Enhanced trust row ── */
function TrustRow({ icon, title, desc, highlight }) {
  return (
    <div style={{ display: "flex", gap: 16, padding: "18px 0", borderBottom: `1px solid ${T.n100}` }}>
      <div style={{
        width: 38, height: 38, borderRadius: 10, flexShrink: 0,
        background: highlight ? T.g500 : T.white,
        border: `1px solid ${highlight ? T.g500 : T.g200}`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <Icon name={icon} size={16} color={highlight ? T.white : T.g500} strokeWidth={1.7} />
      </div>
      <div style={{ flex: 1, paddingTop: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: T.n800, marginBottom: 3 }}>{title}</div>
        <div style={{ fontSize: 14, color: T.n600, lineHeight: 1.65 }}>{desc}</div>
      </div>
    </div>
  );
}

/* ── Testimonial ── */
function Testimonial({ name, location, rating, text }) {
  return (
    <div style={{ padding: "22px", borderRadius: 16, border: `1px solid ${T.n150}`, background: T.white, display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Avatar name={name} />
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.n900 }}>{name}</div>
          <div style={{ fontSize: 12, color: T.n400 }}>{location}</div>
        </div>
      </div>
      <Stars rating={rating} />
      <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: 0, fontStyle: "italic" }}>"{text}"</p>
    </div>
  );
}

/* ── FAQ ── */
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 0", background: "none", border: "none", cursor: "pointer", fontFamily: T.sans, textAlign: "left", gap: 16 }}>
        <span style={{ fontSize: 15, fontWeight: 600, color: T.n800, lineHeight: 1.4 }}>{q}</span>
        <span style={{ flexShrink: 0, color: T.n400 }}><Icon name={open ? "ChevronUp" : "ChevronDown"} size={18} strokeWidth={2} /></span>
      </button>
      {open && <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.75, margin: "0 0 18px", paddingRight: 32 }}>{a}</p>}
    </div>
  );
}

/* ── Section head ── */
function SectionHead({ eyebrow, title, em, sub }) {
  return (
    <div style={{ marginBottom: 6 }}>
      <span style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", display: "block", marginBottom: 6 }}>{eyebrow}</span>
      <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
        {title} <em style={{ fontStyle: "italic", color: T.g600 }}>{em}</em>
      </h2>
      {sub && <p style={{ fontSize: 15, color: T.n400, margin: 0, lineHeight: 1.65 }}>{sub}</p>}
    </div>
  );
}

/* ══ Main page ══ */
export default function BabysittingChildcarePage() {
  useFonts();
  const navigate = useNavigate();

  const faqs = [
    { q: "What does verification involve for caregivers specifically?", a: "Beyond standard identity verification, caregivers on JiraniApp go through a child protection background check and a reference review from previous families where available. We take childcare seriously and apply a higher level of scrutiny than other service categories before a caregiver's profile goes live." },
    { q: "Can I meet or interview a caregiver before booking?", a: "Yes, and we strongly encourage it for ongoing arrangements like a full-time nanny or regular after-school care. Use in-app messaging to ask questions, request a short video call, or arrange an in-person meet and greet before confirming a longer-term booking." },
    { q: "Is there a difference between booking a one-off babysitter and a full-time nanny?", a: "Yes. Occasional babysitting is priced and booked per session for short-notice needs. A full-time nanny is typically a recurring, monthly arrangement that involves a more thorough onboarding process, including a longer trial period and more detailed reference checks given the ongoing nature of the role." },
    { q: "What if I have specific requirements, like a child with allergies or special needs?", a: "You can communicate any specific requirements directly with the caregiver before booking, including allergies, medical needs, or routines that must be followed. For special needs care specifically, look for caregivers who list relevant experience on their profile, and confirm details via message beforehand." },
    { q: "What happens if I am not comfortable with a caregiver after the first booking?", a: "Your comfort and your child's safety come first. If a booking does not go well, you can choose not to rebook that caregiver and can report any concerns directly through the Report a Professional option on their profile. Our Trust and Safety team takes all childcare-related reports seriously and reviews them promptly." },
    { q: "Are caregivers trained in first aid or emergency response?", a: "Many caregivers on JiraniApp list first aid certification on their profile where applicable, but this is not yet a universal requirement across all listings. If first aid training is important for your situation, filter for it specifically or confirm directly with the caregiver before booking." },
  ];

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900 }}>
      <style>{`* { box-sizing: border-box; }`}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "20px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        <button onClick={() => navigate(-1)} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: "none", cursor: "pointer", color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0 }}
          onMouseEnter={e => (e.currentTarget.style.color = T.n800)}
          onMouseLeave={e => (e.currentTarget.style.color = T.n400)}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/pro-onboarding")} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.g600, fontSize: 13, fontFamily: T.sans, fontWeight: 600, padding: 0,
        }}>
          <Icon name="Briefcase" size={14} strokeWidth={2} />
          Are you a caregiver? Join JiraniApp
        </button>
      </div>

      {/* ── Hero ── */}
      <div style={{ padding: "clamp(48px,7vw,84px) 20px clamp(40px,5vw,56px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 7, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 20 }}>
            <Icon name="Baby" size={14} color={T.g500} strokeWidth={2.2} />
            Babysitting & Childcare
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(38px,7vw,60px)", fontWeight: 400, margin: "0 0 18px", lineHeight: 1.08, color: T.n900, letterSpacing: "-0.03em", maxWidth: 580 }}>
            Care you can{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>truly trust</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.75, margin: "0 0 16px", maxWidth: 520 }}>
            From an evening babysitter to a full-time nanny, find caregivers near you who have
            gone through enhanced verification specifically built for childcare.
          </p>

          {/* Inline safety reassurance */}
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "10px 16px", borderRadius: 99, background: T.g50, border: `1px solid ${T.g100}`, marginBottom: 28 }}>
            <Icon name="ShieldCheck" size={15} color={T.g500} strokeWidth={2} />
            <span style={{ fontSize: 13, fontWeight: 600, color: T.g700 }}>Background checked and reference verified</span>
          </div>

          <LocationSearchBar />
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px clamp(80px,10vw,120px)" }}>

        {/* ── Sub-services grid ── */}
        <div style={{ paddingTop: "clamp(40px,6vw,56px)", marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="Services" title="Types of care available on" em="JiraniApp" sub="Pricing varies by duration, experience, and care type. These are typical ranges." />
          <div style={{ marginTop: 20, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 14 }}>
            {SUB_SERVICES.map(s => <SubServiceCard key={s.name} s={s} />)}
          </div>
        </div>

        {/* ── How it works ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="How it works" title="Booking a caregiver," em="step by step" sub="From search to peace of mind in four simple steps." />
          <div style={{ marginTop: 8 }}>
            <HowStep num="01" icon="Search2" title="Search and compare caregivers near you" desc="Enter your area and browse verified caregivers with ratings, experience details, and transparent pricing for each type of care." />
            <HowStep num="02" icon="MessageCircle" title="Message and ask questions first" desc="Before booking, message the caregiver to ask about experience, availability, and anything specific to your child's needs. For ongoing care, consider arranging a meet and greet." />
            <HowStep num="03" icon="Calendar" title="Book and confirm details" desc="Confirm the date, time, and any specific instructions — routines, allergies, emergency contacts. Payment is held securely until the booking is complete." />
            <HowStep num="04" icon="Star" title="Rate your experience" desc="After the booking, leave a rating and review to help other families. Found the right fit? Save the caregiver's profile and book them directly for future care." />
          </div>
        </div>

        {/* ── Enhanced trust section ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)", padding: "clamp(28px,5vw,40px)", borderRadius: 20, background: T.g50, border: `1.5px solid ${T.g200}` }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 7, color: T.g600, fontSize: 11, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 14 }}>
            <Icon name="ShieldCheck" size={13} color={T.g500} strokeWidth={2} />
            Enhanced verification for childcare
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(22px,3.5vw,28px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            A higher standard, because{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>children deserve it</em>
          </h2>
          <p style={{ fontSize: 14, color: T.n600, margin: "0 0 8px", lineHeight: 1.7 }}>
            Childcare carries a different level of responsibility, so we apply additional vetting
            beyond our standard professional verification.
          </p>
          <div style={{ marginTop: 10 }}>
            <TrustRow icon="FileCheck" title="Child protection background check" desc="Every caregiver listed under this category undergoes a dedicated child protection background check in addition to standard identity verification before their profile is approved." highlight />
            <TrustRow icon="Users" title="Reference checks from past families" desc="Where available, we follow up directly with references from families a caregiver has previously worked for, to verify their experience and conduct." highlight />
            <TrustRow icon="Award" title="ID verified and platform accountable" desc="Every caregiver's identity is confirmed and their full booking history is recorded on the platform, creating accountability for every interaction." />
            <TrustRow icon="Star" title="Reviews from real, completed bookings" desc="All ratings and reviews are tied to verified bookings made through JiraniApp, giving you an honest picture from other parents and guardians." />
            <TrustRow icon="Lock" title="Secure payment held until completion" desc="Payment is held securely and only released to the caregiver once the booking is marked complete." />
            <TrustRow icon="MessageCircle" title="Priority dispute handling" desc="Any concern reported regarding a childcare booking is treated as a priority by our Trust and Safety team and reviewed promptly." />
          </div>
        </div>

        {/* ── Testimonials ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="Client stories" title="What parents" em="are saying" />
          <div style={{ marginTop: 20, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 14 }}>
            <Testimonial name="Naomi W." location="Lavington, Nairobi" rating={5} text="We needed a nanny on short notice and found someone wonderful within a day. The background check process gave us real peace of mind before she even started." />
            <Testimonial name="Caleb O." location="Westlands, Nairobi" rating={5} text="Our after-school caregiver has been with us for three months now. My daughter genuinely looks forward to the afternoons. Reliable and warm with the kids." />
            <Testimonial name="Mercy A." location="Nyali, Mombasa" rating={5} text="Booked a one-off babysitter for a wedding we had to attend. She was punctual, attentive, and sent updates throughout the evening without us even asking." />
          </div>
        </div>

        {/* ── FAQ ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="Questions" title="Common" em="questions" sub="Things parents ask before booking a caregiver." />
          <div style={{ marginTop: 8 }}>
            {faqs.map((f, i) => <FaqItem key={i} {...f} />)}
          </div>
        </div>

        {/* ── CTA ── */}
        <div style={{ padding: "clamp(32px,5vw,48px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50 }}>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Find care you can{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>rely on</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            Browse verified caregivers near you and book with confidence.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate("/search?category=childcare")} style={{
              padding: "13px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 14, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
            onMouseEnter={e => (e.currentTarget.style.background = T.g600)}
            onMouseLeave={e => (e.currentTarget.style.background = T.g500)}>
              Find a caregiver
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "13px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 14, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
            onMouseEnter={e => (e.currentTarget.style.borderColor = T.n400)}
            onMouseLeave={e => (e.currentTarget.style.borderColor = T.n200)}>
              How JiraniApp works
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}